/**
 * Previous / next within the list an item was opened from (case round,
 * finding 6, PR #2628). The buttons name themselves to the shared Guru
 * recorder (data-action qcp_prev / qcp_next with the item they step to as
 * data-target-thread-id / data-target-case-id, kanban aa0d3fb6): before this
 * a step and a reload of the next item's URL recorded the same page view,
 * so the usage graph could not count the buttons. The page records the
 * portal_events row in its go() path; the data-action lets the recorder
 * dedupe the two.
 */
import { itemTargetAttr, stepActionName, type ItemStep, type StepDirection } from './itemNav';
import styles from './QualityWorkspace.module.css';

interface ItemNavProps {
  step: ItemStep;
  /** "Triage", "Cases": names the list the item came from. */
  listLabel: string;
  onStep: (no: string, direction: StepDirection) => void;
}

export function ItemNav({ step, listLabel, onStep }: ItemNavProps) {
  return (
    <span className={styles.itemNav} role="group" aria-label={`Items in ${listLabel}`}>
      <button
        type="button"
        className={styles.itemNavBtn}
        disabled={!step.prev}
        onClick={() => step.prev && onStep(step.prev, 'prev')}
        aria-label="Previous item"
        title={step.prev ? `Previous: ${step.prev}` : 'This is the first item'}
        data-action={stepActionName('prev')}
        {...(step.prev ? { [itemTargetAttr(step.prev)]: step.prev } : {})}
      >
        ‹
      </button>
      <span className={styles.itemNavPos}>{step.position}</span>
      <button
        type="button"
        className={styles.itemNavBtn}
        disabled={!step.next}
        onClick={() => step.next && onStep(step.next, 'next')}
        aria-label="Next item"
        title={step.next ? `Next: ${step.next}` : 'This is the last item'}
        data-action={stepActionName('next')}
        {...(step.next ? { [itemTargetAttr(step.next)]: step.next } : {})}
      >
        ›
      </button>
    </span>
  );
}
